import { ref } from 'vue'

/** 表示フラグ（true: 表示, false: 非表示） */
const isOpen = ref<boolean>(false)
const imageUrl = ref<string>('')
export const useZoomBuildingImage = () => {
  /**
   * 開く
   * @param imageUrl ImageUrl
   * @returns なし
   */
  const open = (src: string): void => {
    imageUrl.value = src
    isOpen.value = true
  }

  /**
   * 閉じる
   * @param なし
   * @return なし
   */
  const close = (): void => {
    isOpen.value = false
  }

  /**
   * 変数群のリセット
   * @param なし
   * @returns なし
   */
  const reset = () => {
    isOpen.value = false
  }

  return {
    isOpen,
    imageUrl,
    open,
    close,
    reset
  }
}
